var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{staticClass:"table-loader",class:{ 'text-center': _vm.center },attrs:{"colspan":_vm.colspan}},[_c('Loader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }